import { utils } from '@didi/webx-js-core';
/**
 * SSR缓存同步CSR
 * @param { IStorageData } ssrStorage - 从序列化的模版取出的ssr缓存
 * @param { IStorageData } localStorage - web本地storage
 */
function hydrateMergeStorage(ssrStorage, localStorage) {
    function mergeStorage(ssrStorage, localStorage) {
        /** 默认以ssrStorage为模版，localStorage合并差异 */
        const mergedStorage = Object.assign({}, ssrStorage);
        /** 以本地缓存作为key进行遍历 */
        for (const key in localStorage) {
            const ssrObj = ssrStorage[key];
            const localObj = localStorage[key];
            /** 都是对象需要递归 */
            if (utils.isObj(ssrObj) && utils.isObj(localObj)) {
                mergedStorage[key] = mergeStorage(ssrStorage[key], localStorage[key]);
            }
            else {
                /** 如果双方都有一样的key以ssrStorage为准无需更新 */
                const isUnset = utils.isNull(ssrObj) || utils.isUndefined(ssrObj); // 如果为undefined或null都判定为需要重新赋值
                if (!isUnset && ssrStorage.hasOwnProperty.call(ssrObj, key))
                    continue;
                /** 反之为需要被merge的内容 */
                mergedStorage[key] = localStorage[key];
            }
        }
        return mergedStorage;
    }
    /** 获取merge后的storage */
    const res = mergeStorage(ssrStorage, localStorage);
    /** 激活本地storage */
    Object.keys(localStorage).forEach(k => {
        const v = res[k];
        v && (localStorage[k] = v);
    });
    console.log(' === hydrate 激活成功！ === ', res);
}
/* sdk内部数据缓存 */
const storage = {
    userInfo: {},
    locationInfo: { lat: 0, lng: 0 },
    riskParams: {},
    openId: '',
    webxNineChapterParams: {},
    shareConf: {},
    viewInfo: {},
    serverRenderResource: {},
    launchAppConfig: {}
};
/* seal缓存对象 禁止扩展/删除该对象 */
Object.seal(storage);
/**
 * 获取storage
 */
const getStorage = () => storage;
/** 从序列化模版中取出server storage缓存 */
const getInitialStorage = () => window?.__INITIAL_STATE__?.WEBXJSSDK?.storage;
export { storage, getStorage, getInitialStorage, hydrateMergeStorage };
